import { ScrollCTA } from 'formlabs-web-components/CTAs';
import { Cell, Grid, Section } from 'formlabs-web-components/Grid';
import { LargeLink, SuperButton } from 'formlabs-web-components/Link';
import {
  Picture,
  Video,
  Tile,
  TileGroup,
  CarouselWrapper,
  CompactCard,
  FlushPanel,
  FullWidthImage
} from 'formlabs-web-components/Media';
import {
  PopLockGroup,
  PopLockItem,
  PopLockSection
} from 'formlabs-web-components/PopLock';
import {
  Blockquote,
  Callout,
  Eyebrow,
  Icon
} from 'formlabs-web-components/Type';

import {
  BasicTile,
  BasicTileGroup,
  ButtonPlugin as Button,
  Card,
  CalloutSection,
  CheckmarkList,
  ContactSales,
  Countdown,
  DataSheets as Datasheets,
  DropdownMenu,
  EmbeddedContactSales,
  HeaderPlugin as Header,
  HeroSection,
  MaterialCard,
  MediaLink,
  MenuListSection,
  MiniTechSpecsTable,
  Module,
  NewsletterSignUpSection,
  NumberLine,
  OrderedLinkList,
  Quote,
  QuoteCarousel,
  SimpleCallout,
  SingleDatasheet,
  SocialEmbedSection,
  SocialMediaIcons,
  svgInteractive as SvgInteractive,
  TabbedSection,
  TabbedSectionItem,
  Table,
  TechSpecsItem,
  UnitSwitchSection,
  VideoAccordion,
  VideoAccordionItem,
  VideoCard,
  VideoScrollSection,
  VideoSection,
  WistiaEmbed,
  Wrapper,
  YoutubeEmbed,
  YoutubeModal
} from './content';
import SpecTable, { SpecRow, SpecItem } from './spec-table/SpecTable';
import { NewsletterSignUp, TeaserSignUp, PreformDownload } from './forms/';
import { StarOfDavid } from './star';
import { Graph } from './graph';
import {
  AddToCartPlugin as AddToCart,
  CategoryButtonPlugin as CategoryButton,
  Product,
  ProductHero,
  ProductList,
  ProductCategoryPlugin as ProductCategory,
  ProductDetailPlugin as ProductDetail,
  ProductButtonPlugin as ProductButton
} from './storefront';
import Text from './cms/TextPlugin';
import { ColorPicker } from './colorpicker';
import { Footer, HeaderMenu, Redirect, StoreMenu } from './navigation/';
import { Roi } from './roi';
import { SampleRequest } from './request-sample-part';
import { FeaturedWebinar, WebinarList } from './webinars';

// Provides the component to cms placeholder mapping
export default {
  AddToCart,
  CategoryButton,
  NewsletterSignUp,
  PreformDownload,
  Product,
  ProductButton,
  ProductCategory,
  ProductDetail,
  ProductHero,
  ProductList,
  TeaserSignUp,
  ScrollCTA,
  SpecItem,
  SpecRow,
  SpecTable,
  StarOfDavid,
  StarOfDavidWithOptions: StarOfDavid,
  Graph,

  Blockquote,
  Callout,
  Eyebrow,
  Icon,

  PopLockGroup,
  PopLockItem,
  PopLockSection,

  Picture,
  Video,
  Tile,
  TileGroup,
  CarouselWrapper,
  CompactCard,
  FlushPanel,
  FullWidthImage,

  Cell,
  Grid,
  Section,

  LargeLink,
  SuperButton,

  Card,
  FourColumn: Grid,
  FullCard: Card,
  Scroll: ScrollCTA,
  SvgInteractive,
  Text,
  ThreeColumn: Grid,
  TwoColumn: Grid,
  carousel: CarouselWrapper,
  BasicTile,
  BasicTileGroup,
  CalloutSection,
  CheckmarkList,
  ContactSales,
  Countdown,
  Datasheets,

  Button,
  DropdownMenu,
  EmbeddedContactSales,
  Header,
  HeroSection,
  MaterialCard,
  MediaLink,
  MenuListSection,
  MiniTechSpecsTable,
  Module,
  NewsletterSignUpSection,
  NumberLine,
  OrderedLinkList,
  Quote,
  QuoteCarousel,
  SimpleCallout,
  SingleDatasheet,
  SocialEmbedSection,
  SocialMediaIcons,
  TabbedSection,
  TabbedSectionItem,
  Table,
  TechSpecsItem,
  UnitSwitchSection,
  VideoAccordion,
  VideoAccordionItem,
  VideoCard,
  VideoScrollSection,
  VideoSection,
  WistiaEmbed,
  Wrapper,
  YoutubeEmbed,
  YoutubeModal,

  ColorPicker,

  Footer,
  HeaderMenu,
  Redirect,
  StoreMenu,

  Roi,
  SampleRequest,
  FeaturedWebinar,
  WebinarList
};
